export default __webpack_public_path__ + "static/media/gym_1.1ac6cf27.png";